import {
  SchemaConstants,
  Constants as SharedConstants,
} from '@applyonline/shared/types'

interface PersonalConstants extends SchemaConstants {
  MaxIncomes: number
  HousingToIncomeRatioThreshold: number
  MaxLoanAmountMedicard: number
  MaxTermUnderAmountThreshold: number
  LongTerm: number
  AmountThresholdForLowerTerm: number
  LargeLoanAmount: number
}

export const Constants: PersonalConstants & typeof SharedConstants = {
  ...SharedConstants,
  IncludeCoapplicant: true,
  FinanceFeeRateForRegular: 0.06,
  BaseMinTerm: 12,
  BaseMaxTerm: 72,
  CorrectedMaxTerm: 60,
  MinIncomes: 21000,
  MaxIncomes: 1000000,
  HousingToIncomeRatioThreshold: 0.35,
  MinLoanAmount: 500,
  MaxLoanAmount: 40000,
  MaxLoanAmountMedicard: 50000,
  MaxRate: 29.99,
  LargeLoanAmount: 10000,
  LongTerm: 84,
  MaxTermUnderAmountThreshold: 60,
  AmountThresholdForLowerTerm: 3000,
}

export interface PartnerReferral {
  id: string
  logoUrl: string
  url: string
}

export const EPartnerReferral: PartnerReferral[] = [
  {
    id: 'neo',
    logoUrl: 'https://icebergstatic.blob.core.windows.net/b2c-merchant-logos/24584.png',
    url: `${import.meta.env.VITE_NEO_APP_URL}/?cid=personal&sid=0&mid=0&br=0`,
  },
]
